
























import {Component, Mixins, Vue} from "vue-property-decorator";
import GuestLayout from "@/layout/page/GuestLayout.vue";
import LoginForm from "@/components/forms/account/LoginForm.vue";
import Branding from "@/components/Branding.vue";
@Component({
    components:{
        Branding,
        LoginForm,GuestLayout
    }
})
export default class Login extends Vue{

};
